export default __webpack_public_path__ + "static/media/sticker_thumbnail.2683db0a.png";